/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Expand = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 -5 34 40">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.75 9C24.75 8.44772 24.3023 8 23.75 8C23.1977 8 22.75 8.44772 22.75 9V23C22.75 23.5523 23.1977 24 23.75 24C24.3023 24 24.75 23.5523 24.75 23V9ZM12.0429 9.29289C11.6524 9.68342 11.6524 10.3166 12.0429 10.7071L16.3358 15H6.25C5.69772 15 5.25 15.4477 5.25 16C5.25 16.5523 5.69772 17 6.25 17H16.3358L12.0429 21.2929C11.6524 21.6834 11.6524 22.3166 12.0429 22.7071C12.4334 23.0976 13.0666 23.0976 13.4571 22.7071L19.4571 16.7071C19.8476 16.3166 19.8476 15.6834 19.4571 15.2929L13.4571 9.29289C13.0666 8.90237 12.4334 8.90237 12.0429 9.29289Z"
      />
      <path d="M16 1C7.71573 1 1 7.71573 1 16H-1C-1 6.61116 6.61116 -1 16 -1V1ZM31 16C31 7.71573 24.2843 1 16 1V-1C25.3888 -1 33 6.61116 33 16H31ZM16 31C24.2843 31 31 24.2843 31 16H33C33 25.3888 25.3888 33 16 33V31ZM16 33C6.61116 33 -1 25.3888 -1 16H1C1 24.2843 7.71573 31 16 31V33Z" />
    </BaseSvgIcon>
  )
}

export default Expand
